import './Sitelogo.css.proxy.js';
/* src/components/element/Sitelogo.svelte generated by Svelte v3.35.0 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_element,
	detach,
	element,
	init,
	insert,
	noop,
	safe_not_equal
} from "../../web_modules/svelte/internal.js";

function create_fragment(ctx) {
	let a;
	let img;
	let img_src_value;

	return {
		c() {
			a = element("a");
			img = element("img");
			this.h();
		},
		l(nodes) {
			a = claim_element(nodes, "A", { href: true, class: true });
			var a_nodes = children(a);
			img = claim_element(a_nodes, "IMG", { src: true, alt: true, class: true });
			a_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (img.src !== (img_src_value = "/images/logo.png")) attr(img, "src", img_src_value);
			attr(img, "alt", "株式会社アルベロ");
			attr(img, "class", "svelte-zfrhra");
			attr(a, "href", "/");
			attr(a, "class", "svelte-zfrhra");
		},
		m(target, anchor) {
			insert(target, a, anchor);
			append(a, img);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(a);
		}
	};
}

class Sitelogo extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default Sitelogo;
//# sourceMappingURL=Sitelogo.js.map
